import React from 'react'
import { connect } from 'react-redux'
import moment from 'moment'

import BaseComponent from 'utils/BaseComponent'
import request from 'utils/request'

import RetractablePanel from 'components/RetractablePanel'
import Button from 'components/Button'

import { statusChanged } from 'components/RequestStatus/actions'
import { claimChanged } from 'scenes/VehicleDetail/actions'

import { CLAIM_TYPES, CLAIM_UPDATE } from 'constants'
import { STATES_URL, CITIES_URL } from 'constants'

import './styles.scss'

export class About extends BaseComponent {


  constructor(props) {
    super(props)
    this.state = {
      type: {
        label: props.claim.type
      },
      isActive: props.claim.is_active,
      isClosed: props.claim.is_closed,
      number: props.claim.number,
      states: [],
      cities: [],
      state: '',
      stateName: '',
      city: '',
      cityName: '',
      cityObject: '',
      location_details: props.claim.location_details || '',
      incidence_date: '',
      incidence_time: ''
    }

    this._bind( 
                '_getIncidenceDateValue',
                '_renderData', '_renderBadge', '_renderSMSBadge',
                '_fetchTypes', '_getType', '_claimStatus',
                '_fetchStates', '_onStateChange', '_onCityChange', '_convertToOption',
                '_getPlaceString', '_setCityValues', '_getDays')
  }

  _getIncidenceDateValue() {
    const claim = this.props.claim
    if (claim.incidence_date) {
      const incidence_date = moment(claim.incidence_date)
      const incidenceElement = incidence_date.format('YYYY-MM-DD')
      const incidenceTimeElement = incidence_date.format('HH:mm')
      this.setState({
        incidence_date: incidenceElement,
        incidence_time: incidenceTimeElement
      })
    }
  }

  componentDidMount() {
    this._setCityValues()
    this._getIncidenceDateValue()
    this._fetchStates()
  }

  _fetchTypes(label) {
    return request(CLAIM_TYPES)
      .then(({types}) => {
        const options = types.map((item) => ( { value: item.id, label: item.name } ))
        return { options }
      })
      .catch(console.log)
  }

  _convertToOption(item) {
    return { value: item.id, label: item.name }
  }

  _fetchStates() {
    return request(STATES_URL)
    .then((response) => {
      // const states = response.states.map(this._convertToOption)
      const states = response.states.map((item) => ( { value: item.id, label: item.name } ))
      this.setState({ states })
      return { states }
    })
    .catch((err) => console.log(err))
  }

  _onStateChange(selectedOption) {
    const stateID = !!selectedOption ? selectedOption.value : null
    this.setState({ state: stateID })

    // this.props.filterChanged(stateID, null)
    request(CITIES_URL(stateID))
    .then((response) => {
      const cities = response.cities.map(this._convertToOption)
      this.setState({ cities })
      return { cities }
    })
    .catch((err) => console.log(err))
  }

  _onCityChange(selectedOption) {
    const cityID = !!selectedOption ? selectedOption.value : null
    this.setState({ city: cityID, cityName: selectedOption.label })
  }

  _claimStatus(e) {
    const formData = new FormData()
    formData.append([e.target.name], true)
    this.props.updateRequestStatus('progress', 'Cambiando estado de siniestro...')
    request(CLAIM_UPDATE(this.props.claim.id), {
      method: 'PUT',
      isUpload: true,
      body: formData
    }).then((res) => {
      this.setState({
        isActive: res.is_active,
        isClosed: res.is_closed,
      })
      this.props.updateRequestStatus('ok', 'Modificación exitosa')
    }).catch((err) => {
      this.props.updateRequestStatus('error', 'No pudimos modificar el estado')
    })
  }


  _renderBadge() {
    const isActive = this.state.isActive
    const isClosed = this.state.isClosed
    if(isActive && isClosed === false) {
      return (
        <Button className="justify-content-center badge_active" buttonType="primary" size="label">
          Activo
        </Button>
      )
    } else {
      return (
        <Button className="justify-content-center badge_closed" buttonType="danger" size="label">
          Cerrado
        </Button>
      )
    }
  }

  _renderSMSBadge() {
    const sms_enabled = this.props.claim.sms_enabled
    return (sms_enabled === true) ? (
      <Button className="justify-content-center badge_sms" buttonType="primary" size="label">
        SMS Activos
      </Button>
    ) : null
  }

  _getType(selectedOption) {
    this.setState({
      type: selectedOption
    })
  }

  _setCityValues(){
    let city = this.props.claim.city
    if (city){
      this.setState({
        state: city.state,
        city: city.id,
        cityName: city.name,
        stateName: city.state_name
      })
      this._onStateChange({ value: city.state, label: city.state_name })
    }
  }

  _getPlaceString(){
    const states = this.state.states
    const city = this.props.claim.city
    let placeString = ""
    if (city && city.state){
      for (var i = 0; i < states.length; i++){
        if (states[i].value === city.state) {
          placeString = states[i].label + ", " + city.name
          break
        }
      }
    }
    return placeString
  }

  _getDays(claim) {
    const date = claim.activation_date
    if(!!claim.is_active && !claim.is_closed) {
      var days = 0
      if (!!date) {
        var moment_date = moment(date)
        days = moment().diff(moment_date, 'days')
      }
      return days + ' días'
    } else if (!!claim.normal_chronology && claim.chronology_days) {
      return claim.chronology_days + ' días'
    } else if (!!claim.is_closed && claim.total_days && claim.total_days >= 0) {
      return claim.total_days + ' días'
    }
    return '-'
  }


  _renderData() {
    const claim = this.props.claim
    const date = moment(claim.created)
    const dateElement = date.format('DD-MM-YYYY')
    const placeString = this._getPlaceString()
    const total_days = this._getDays(claim)
    let workshop = '' 
    let workshop_phone = ''
    if (claim.workshop){
      workshop = claim.workshop.name
      workshop_phone = claim.workshop.phone
    }
  
    let incidenceElement = ''
    let incidenceTimeElement = ''
    if (claim.incidence_date){
      const incidence_date = moment(claim.incidence_date)
      incidenceElement = incidence_date.format('DD-MM-YYYY')
      incidenceTimeElement = incidence_date.format('HH:mm')
    }
      
    return(
      <div className="SinisterAbout__data">
        <p className="type">Tipo de siniestro: <span>{claim.type}</span></p>
        <p>Folio: <span>{claim.number || '-'}</span></p>
        <p>Duración: <span>{total_days || '-'}</span></p>
        <p>Creado el: <span>{dateElement}</span></p>
        <p>Fecha del siniestro: <span>{incidenceElement || '-'}</span></p>
        <p>Hora del siniestro: <span>{incidenceTimeElement || '-'}</span></p>
        <p>Lugar: <span>{placeString || '-'}</span></p>
        <p>Referencia del lugar: <span>{claim.location_details || '-'}</span></p>
        <p>Taller: <span>{workshop || '-'}</span></p>
        <p>Teléfono: <span>{workshop_phone || '-'}</span></p>
        <div className="controls d-flex">
          {this._renderBadge()}
          {this._renderSMSBadge()}
        </div>
      </div>
    )
  }

  render() {
    return(
      <div id="SinisterAbout" className="SinisterAbout">
        <RetractablePanel
          ref={(panel) => this.panel = panel}
          name="Resumen"
          isToggle={true}
        >
          {this._renderData()}
        </RetractablePanel>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    claim: state.vehicleDetail.get('claim')
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    updateRequestStatus: (status, message) => dispatch(statusChanged(status, message)),
    claimChanged: (vehicle) => dispatch(claimChanged(vehicle))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(About)



// WEBPACK FOOTER //
// ./src/scenes/VehicleDetail/components/Claim/About/index.js